import { CompanyShortDto } from '../../models/companies/companyShortDto';

/** Убирает дубликаты по id (на случай гонок запросов). */
export function dedupeCompaniesById(items: CompanyShortDto[]): CompanyShortDto[] {
    const byId = new Map<number, CompanyShortDto>();
    for (const item of items) {
        byId.set(item.id, item);
    }
    return Array.from(byId.values());
}
